const boneTempleRentOffer = {
	id: 'b2Z8dG0xNTc2OTc0OkVTOmFtejpyZW50Omhk',
	presentationType: 'HD',
	monetizationType: 'RENT',
	newElementCount: 0,
	retailPrice: '12,99€',
	retailPriceValue: 12.99,
	userLocalCurrency: null,
	retailPriceConverted: null,
	currency: 'EUR',
	lastChangeRetailPriceValue: null,
	type: 'STANDARD',
	country: 'ES',
	package: {
		id: 'cGF8MTA=',
		packageId: 10,
		clearName: 'Amazon Video',
		shortName: 'amz',
		technicalName: 'amazon',
		icon: '/icon/340823436/s100/amazon.{format}',
		iconWide: '/icon_wide/340823437/s160/amazon.{format}',
		planOffers: [],
		__typename: 'Package',
	},
	plans: [],
	standardWebURL: 'https://app.primevideo.com/detail?gti=amzn1.dv.gti.71154e3a-a364-4edd-8f5d-1b9d725e9a61',
	preAffiliatedStandardWebURL: null,
	streamUrl: null,
	streamUrlExternalPlayer: null,
	elementCount: 0,
	availableTo: null,
	subtitleLanguages: ['de', 'en', 'fr', 'ja', 'pl', 'pt', 'es', 'fi', 'it', 'nl', 'sv'],
	videoTechnology: [''],
	audioTechnology: ['_5_POINT_1'],
	audioLanguages: ['es', 'de', 'fr', 'it', 'ja', 'pl', 'pt', 'en', 'hi'],
	__typename: 'Offer',
	offerSeasons: null,
	minRetailPrice: null,
} as const;

export function getBoneTempleRentOffer(country: string, titleId: string) {
	if (country === 'ES' && titleId === 'tm1576974') {
		return boneTempleRentOffer;
	}

	return null;
}
